import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { FilterType } from '@homeviews/models'

export const STATISTICS_FEATURE_KEY = 'statistics'

type DashboardLocalFilters = {
  activeDevs: string
  activeCompanies: string
  reviewerType: string
  datePeriod: any
}

type StatisticsState = {
  filters: any
  dashboardLocalFilters: DashboardLocalFilters
}

const initialStatisticsState: StatisticsState = {
  filters: {
    benchmark_type: 'all_time',
  },
  dashboardLocalFilters: {
    activeDevs: '',
    activeCompanies: '',
    reviewerType: '',
    datePeriod: '',
  },
}

export const statisticsSlice = createSlice({
  name: STATISTICS_FEATURE_KEY,
  initialState: initialStatisticsState,
  reducers: {
    setStatisticsFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      if (filter === 'development' || filter === 'reviewer_type') {
        filter += '[]'
      }
      const currentFilters = state.filters
      if (!value) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          [filter]: value,
        }
      }
    },
    setBulkStatisticsFilter: (
      state,
      { payload }: PayloadAction<{ filter: FilterType; value: any }[]>,
    ) => {
      let currentFilters = state.filters
      payload.forEach(({ filter, value }) => {
        if (!value) {
          delete currentFilters[filter]
        } else {
          currentFilters = {
            ...currentFilters,
            [filter]: value,
          }
        }
      })
      state.filters = currentFilters
    },
    setDashboardLocalFilters: (
      state,
      { payload }: PayloadAction<{ filters: DashboardLocalFilters }>,
    ) => {
      state.dashboardLocalFilters = payload.filters
    },
    clearStatisticsFilters: (state) => {
      state.filters = {
        benchmark_type: 'all_time',
      }
      state.dashboardLocalFilters = {
        activeDevs: '',
        activeCompanies: '',
        reviewerType: '',
        datePeriod: '',
      }
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const statisticsReducer = statisticsSlice.reducer

export const {
  setStatisticsFilter,
  setBulkStatisticsFilter,
  setDashboardLocalFilters,
  clearStatisticsFilters,
} = statisticsSlice.actions

export const getStatisticsState = (rootState: unknown): StatisticsState =>
  rootState[STATISTICS_FEATURE_KEY]

export const selectStatisticsFilters = (rootState: unknown) =>
  rootState[STATISTICS_FEATURE_KEY]?.filters

export const selectDashboardLocalFilters = (rootState: unknown) =>
  rootState[STATISTICS_FEATURE_KEY]?.dashboardLocalFilters
